export interface SqlHistoryEntry {
  schema: 'dev' | 'staging' | 'production';
  sql: string;
  durationMs: number;
  rowCount: number;
  ts: number;
}

const KEY = 'master-data-sql-history';
const MAX = 20;

export function loadSqlHistory(): SqlHistoryEntry[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function pushSqlHistory(entry: SqlHistoryEntry): void {
  const current = loadSqlHistory();
  const top = current[0];
  if (top && top.schema === entry.schema && top.sql === entry.sql) {
    current[0] = entry;
  } else {
    current.unshift(entry);
  }
  const trimmed = current.slice(0, MAX);
  try {
    localStorage.setItem(KEY, JSON.stringify(trimmed));
  } catch {
    /* quota exceeded — silently drop */
  }
}

export function clearSqlHistory(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
